var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlob = function SvgGlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 274,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 154.773c0 82.866-65.065 149.772-145 149.772s-145-66.906-145-149.772C-164 71.907-98.935 5-19 5s145 66.907 145 149.773Z",
    fill: "#fff",
    stroke: "#8CC8FF",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218 236.773c0 82.866-65.065 149.772-145 149.772S-72 319.639-72 236.773C-72 153.907-6.935 87 73 87s145 66.907 145 149.773Z",
    fill: "#fff",
    stroke: "#8CC8FF",
    strokeWidth: 10
  })));
};

export default SvgGlob;